import Stack, { StackProps } from '@mui/material/Stack';
import { forwardRef } from 'react';

interface IProps {
  children?: React.ReactNode;
  component?: React.ElementType;
}

const StackWrapper = forwardRef<unknown, IProps & StackProps>(({ children, ...props }, ref) => (
  <Stack ref={ref} {...props}>
    {children}
  </Stack>
));

export default StackWrapper;
